import axios from "axios";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { refreshJwtToken } from "../../user/api/refresh-jwt-token";

const backendUrl = import.meta.env.VITE_API_BASE_URL;

/*
 * Для получения нового токена мы должны использовать чистый axios instance,
 * чтобы не вызывать интерцепторы. Для первой версии так не получится, из-за
 * хардкода baseURL
 * */

/*
 * Так как мы лезем во внутренний api для обновления токена - мы не знаем realm,
 * который необходимо указать. Поэтому, в первый раз проверяем два реалма последовательно.
 * А в дальнейшем, определяем realm по issuer'у accessToken'а второй версии.
 * */
export async function getRefreshTokenFromOldAccess(
  legacyAccessToken: string,
  accessToken?: string | null,
) {
  const payload = jwtDecode<{ email: string } & JwtPayload>(legacyAccessToken);
  // изначально axios не кодирует non-ascii символы
  const username = new URLSearchParams({ username: payload.email });

  if (accessToken) {
    const { iss } = jwtDecode(accessToken);
    const [, realm] = iss?.match(/realms\/([a-zA-Z]+)/) ?? [];
    const response = await axios.post(
        `${backendUrl}/auth-adapter/api/v1/auth/realms/${realm}/token?${username}`,
        {
          callback_token: legacyAccessToken,
        },
      );
    return response.data as {
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
    };
  }

  let tokens;

  const realm = localStorage.getItem('REALM') || 'BUILDDOCS';

  try {
    const response = await axios.post(
        `${backendUrl}/auth-adapter/api/v1/auth/realms/${realm}/token?${username}`,
        {
          callback_token: legacyAccessToken,
        },
      );
    tokens = response.data as {
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
    };
  } catch (e) {
    const response = await axios.post(
        `${backendUrl}/auth-adapter/api/v1/auth/realms/${realm}/token?${username}`,
        {
          callback_token: legacyAccessToken,
        },
      );
    tokens = response.data as {
      accessToken: string;
      tokenType: string;
      expiresIn: number;
      refreshToken: string;
    };
  }

  return tokens as {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
    refreshToken: string;
  };
}

// refresh token и access token взаимозаменяемы в 1 bd.
export async function getLegacyAccessToken(legacyAccessToken: string) {
  const response = await refreshJwtToken(legacyAccessToken);
  const { jwtToken } = response.data;

  return jwtToken;
}

// refresh token и access token взаимозаменяемы в 1 bd.
export async function getLegacyRefreshToken(legacyAccessToken: string) {
  const response = await refreshJwtToken(legacyAccessToken);
  const { refreshToken } = response.data;

  return refreshToken;
}

// FIXME: 401 при любых запросах
// async function getNewTokens(refreshToken: string) {
//   return (await axios
//     .put(
//       `${backendUrl}/auth-adapter/api/v1/auth/realms/BUILDDOCS/token`,
//       {
//         refreshToken,
//       },
//     )
//     .then((r) => r.data)
//     .catch((e) => console.log(e))) as {
//     accessToken: string;
//     tokenType: string;
//     expiresIn: number;
//     refreshToken: string;
//   };
// }

